import { Alert, Modal, Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useMoveExpenseToGroup } from "../../api/api";
import { useGetGroups2 } from "../../api/api.get";
import { useGroupContext } from "../../providers/groups.provider";
import { IExpense2 } from "../../types/types";

export default function SaveAsGroupExpenseDialog({
  open,
  onCancel,
  onOk,
  expense,
}: {
  expense?: IExpense2;
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}) {
  const { defaultGroupId } = useGroupContext();

  const { mutateAsync, error } = useMoveExpenseToGroup(
    defaultGroupId,
    expense?.id,
  );
  const { data: groupsData } = useGetGroups2();

  const optionsData = useMemo(() => {
    if (groupsData) {
      return groupsData
        .filter((g) => g.id !== defaultGroupId)
        .map((g) => {
          return { label: g.name, value: g.id };
        });
    }
  }, [groupsData, defaultGroupId]);

  const [selectedNewGroupId, setSelectedNewGroupId] = useState<
    string | undefined
  >();

  useEffect(() => {
    if (optionsData) {
      setSelectedNewGroupId(optionsData[0]?.value);
    }
  }, [optionsData]);

  const handleSubmit = () => {
    mutateAsync({ newGroupId: selectedNewGroupId! }).then(onOk);
  };

  return (
    <Modal
      title="Change To Another Group?"
      closable={{ "aria-label": "Custom Close Button" }}
      open={open}
      onOk={handleSubmit}
      onCancel={onCancel}
    >
      <div className="flex flex-col justify-center items-center mb-10">
        {error && (
          <Alert type="error" title={"Unable to process. Please try again"} />
        )}
        <div className="flex mt-4 gap-5">
          <Select
            style={{ width: 300 }}
            placeholder="Select a group"
            onChange={(value) => setSelectedNewGroupId(value)}
            options={optionsData}
            value={selectedNewGroupId}
          />
        </div>
      </div>
    </Modal>
  );
}
